import React, { useContext, useEffect, useState } from "react";
import DefaultLayout from "../layouts/DefaultLayout";
import { AccountContext } from "../store/AccountContext";
import { Navigate, useLocation } from "react-router-dom";
import querystring from "query-string";
import BackdropLoader from "./common/BackdropLoader";

// #990: take the sign-in token (`alt`) out of the address bar as soon
// as it has been read, so a reloaded or restored tab can't send it again and it
// doesn't stay in browser history. window.history.replaceState, not the
// router's navigate: the router doesn't see this change, so location.search
// (and the effect below) stays as it was, and the router's own history state
// is passed through unchanged.
export const removeTokenFromAddressBar = () => {
  const { pathname, search, hash } = window.location;
  const params = querystring.parse(search);
  if (!("alt" in params)) return;
  delete params.alt;
  const rest = querystring.stringify(params);
  window.history.replaceState(
    window.history.state,
    "",
    `${pathname}${rest ? `?${rest}` : ""}${hash}`,
  );
};

const AutoLogin = () => {
  const { loginWithAutoLoginToken } = useContext(AccountContext);
  const [redirectTo, setRedirectTo] = useState<string>();
  const location = useLocation();

  // One time - on mount
  useEffect(() => {
    if (!location.search || redirectTo) return;

    const { alt, rd } = querystring.parse(location.search);
    // Never log the token itself.
    console.log("[auto-login] link has token:", !!alt, "rd:", rd);
    removeTokenFromAddressBar();
    if (alt && typeof alt === "string" && alt.length > 0) {
      loginWithAutoLoginToken(alt)
        .then(() => {
          console.log(
            "Setting Redirect To",
            rd && typeof rd === "string" ? rd : "/",
          );
          setRedirectTo(rd && typeof rd === "string" ? rd : "/");
        })
        .catch((e) => {
          console.error("Error logging in with auto login token", e);
          setRedirectTo("/");
        });
    } else {
      setRedirectTo("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return (
    <DefaultLayout>
      {redirectTo !== undefined && <Navigate to={redirectTo} replace />}
      <BackdropLoader />
    </DefaultLayout>
  );
};

export default AutoLogin;
